import { useEffect } from 'react';
import useFetchData from '../../hooks/useFetchData';

const PaymentSuccessPage = () => {
  const { data } = useFetchData(
    `payment/payment_success${window.location.search}`
  );

  useEffect(() => {
    if (data && data.success) {
      // alert('תשלום בוצע בהצלחה')
      window.top.location.reload();
    }
  }, [data]);

  return (
    <div
      style={{
        textAlign: 'center',
        padding: '20px',
        color: '#84BD00',
        fontSize: '20px'
      }}
    >
      תשלום בוצע
    </div>
  );
};

export default PaymentSuccessPage;
